export type ActionType =
  | 'investment-entity-association'
  | 'article-approval'
  | 'placeholder-contact'
  | 'content-review'
  | 'expired-email-change'
  | 'rejected-email-change';

export interface Action {
  name: string;
  associatedModel: string;
  associatedModelId: string;
  actionType: ActionType;
  fulfillmentLink: string;
  resolutionAction: string;
  createdAt: string;
  updatedAt: string;
}

export interface BackendAction {
  name: string;
  associatedModel: string;
  associatedModelId: string;
  actionType: ActionType;
  createdAt: string;
  updatedAt: string;
}

export const processBackendAction = (action: BackendAction): Action => {
  switch (action.actionType) {
    case 'investment-entity-association':
      return {
        ...action,
        fulfillmentLink: `/associate-entity/${action.associatedModelId}`,
        resolutionAction: 'Associate Entity',
      };
    case 'article-approval':
      return {
        ...action,
        fulfillmentLink: `/articles/${action.associatedModelId}`,
        resolutionAction: 'Review Article',
      };
    case 'placeholder-contact':
      return {
        ...action,
        fulfillmentLink: `/placeholderContact/${action.associatedModelId}`,
        resolutionAction: 'Review Placeholder Contact',
      };
    case 'content-review':
      return {
        ...action,
        fulfillmentLink: `/review/${action.associatedModelId}`,
        resolutionAction: 'Review Content',
      };
    case 'expired-email-change':
    case 'rejected-email-change':
      return {
        ...action,
        fulfillmentLink: `/contacts/${action.associatedModelId}`,
        resolutionAction: 'View Contact',
      };
    default:
      return { ...action, fulfillmentLink: '', resolutionAction: '' };
  }
};
